var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('TopBar',{on:{"on-signout":_vm.onSignout}}),_c('router-view'),_c('div',{staticClass:"p-5"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }